'use client';

import {
  Tabs as NextUITabs,
  TabsProps,
  Tab as NextUITab,
} from "@heroui/tabs";
import { motion } from 'framer-motion';
import { useTranslations } from 'next-intl';

interface CustomTabProps extends TabsProps {
  data: any;
  isTranslated?: boolean;
}

const Tab = ({ data, isTranslated = true, ...props }: CustomTabProps) => {
  const t = useTranslations();

  return (
    <NextUITabs
      variant="light"
      items={data}
      className="mt-12 w-full"
      radius="full"
      classNames={{
        tab: 'w-full min-w-[10rem] md:min-w-[14rem] bg-white [&>div]:text-title-black/60 [&>div]:font-medium [&>div]:text-base h-10 data-[hover=true]:opacity-80',
        cursor: 'bg-custom-primary',
        tabList: 'gap-5 rounded-none max-sm:w-full',
        tabContent: 'group-data-[selected=true]:text-white',
        panel: 'mt-6',
      }}
      {...props}
    >
      {(item: any) => (
        <NextUITab
          key={item.id}
          title={
            typeof item.label === 'string'
              ? isTranslated
                ? t(item.label)
                : item.label
              : item.label
          }
        >
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.3 }}
          >
            {item.content}
          </motion.div>
        </NextUITab>
      )}
    </NextUITabs>
  );
};

export default Tab;
